import { observable } from "mobx";
import Model from "./Model";

class Page extends Model {
  /**
   * @property {number}
   */
  @observable customerId = null;

  /**
   * @property {number}
   */
  @observable pageId = null;

  /**
   * @property {string}
   */
  @observable title = "";

  /**
   * @property {string}
   */
  @observable slug = "";

  /**
   * @property {string}
   */
  @observable description = "";

  /**
   * @property {boolean}
   */
  @observable isActive = false;

  /**
   * @property {boolean}
   */
  @observable isToursPage = false;

  /**
   * @property {string}
   */
  @observable photoUrl = null;

  /**
   * @property {string} photo base64 encoded
   */
  @observable photoData = "";

  /**
   * @property {string}
   */
  @observable photoPathWeb = "";
}

export default Page;
